import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { PapiDeviation, PapiRequestDaSharedDeviationFetch } from '@wix/da-papi-types';
import { NormalizedDeviation } from '../normalizr/types';
import { putEntities } from '../entities/actions';
import { deviationSchema } from '../normalizr/schemas/deviation';
import { normalize } from 'normalizr';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { createWithDeviation, createWithDeviationAndText } from '../../DaEditorNg/creators';

export interface FetchDeviationPayload extends PapiRequestDaSharedDeviationFetch {
  onSuccess?: (deviation: PapiDeviation) => void;
}

export type EditDeviationPayload = {
  deviation: PapiDeviation;
};

export type EditDeviationSuccessPayload = {
  deviation: PapiDeviation;
};

export enum OnUnpublishCompleteAction {
  ReloadStashPage = 'reload-stash-page',
  Toast = 'toast',
}
export type UnpublishDeviationPayload = {
  deviation: PapiDeviation;
  onCompleteAction: OnUnpublishCompleteAction;
};

export type UnpublishDeviationSuccessPayload = {
  deviation: PapiDeviation;
  onCompleteAction: OnUnpublishCompleteAction;
};

export type DeleteDeviationPayload = {
  deviation: PapiDeviation;
  shouldRedirect?: boolean;
  redirectTo?: string;
};

export type DeleteDeviationSuccessPayload = {
  deviation: PapiDeviation;
};

export type BatchDeviationUpdateCompletePayload = {
  batchId: number;
  name: string;
  processedCount: number;
  failedCount: number;
};

export const fetchDeviation = createAction(
  `${actionTypePrefix}.FETCH_DEVIATION`,
  (payload: FetchDeviationPayload) => payload
);

export const editDeviation = createAction(
  `${actionTypePrefix}.EDIT_DEVIATION`,
  (payload: EditDeviationPayload) => payload
);

export const editDeviationSuccess = createAction(
  `${actionTypePrefix}.EDIT_DEVIATION_SUCCESS`,
  (payload: EditDeviationSuccessPayload) => payload
);

export const unpublishDeviation = createAction(
  `${actionTypePrefix}.UNPUBLISH_DEVIATION`,
  (payload: UnpublishDeviationPayload) => payload
);

export const unpublishDeviationSuccess = createAction(
  `${actionTypePrefix}.UNPUBLISH_DEVIATION_SUCCESS`,
  (payload: UnpublishDeviationSuccessPayload) => payload
);

export const deleteDeviation = createAction(
  `${actionTypePrefix}.DELETE_DEVIATION`,
  (payload: DeleteDeviationPayload) => payload
);

export const deleteDeviationSuccess = createAction(
  `${actionTypePrefix}.DELETE_DEVIATION_SUCCESS`,
  (payload: DeleteDeviationSuccessPayload) => payload
);

export const batchDeviationUpdateComplete = createAction(
  `${actionTypePrefix}.BATCH_DEVIATION_UPDATE_COMPLETE`,
  (payload: BatchDeviationUpdateCompletePayload) => payload
);

export const updateDeviationEntity = (deviation: PapiDeviation) => {
  const { entities } = normalize(deviation, deviationSchema);
  return putEntities({ entities });
};

export const updateNormalizedDeviationEntity = (normalizedDeviation: NormalizedDeviation) =>
  putEntities({
    entities: {
      [deviationSchema.key]: {
        [normalizedDeviation.entityId]: normalizedDeviation,
      },
    },
  });

export const shareDeviationToPost = (deviation: PapiDeviation) =>
  pushModal(ModalType.STATUS_UPDATE, {
    wrapInModal: false,
    params: {
      initialState: createWithDeviation(deviation),
    },
  });

export const shareDeviationAndTextToPost = (deviation: PapiDeviation, text: string) =>
  pushModal(ModalType.STATUS_UPDATE, {
    wrapInModal: false,
    params: {
      initialState: createWithDeviationAndText(deviation, text),
    },
  });
